import { render, staticRenderFns } from "./NlpBurgerMenu.vue?vue&type=template&id=543185ec"
import script from "./NlpBurgerMenu.vue?vue&type=script&lang=js"
export * from "./NlpBurgerMenu.vue?vue&type=script&lang=js"
import style0 from "./NlpBurgerMenu.vue?vue&type=style&index=0&id=543185ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports